export class News2 {
    public Title: string
    public ID: bigint
    public Code: string
    public pictureId: string
    public Text: string
    public SubTitle: string
    public shamsi: string
    public shamsiCreationDate: string
    public hour: string
    public time: string
    public categories: string
    public categoriesIdList: string[]
    public newsType: string
    public newsTypeDisplayName: string
}